import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentProjectApi from '../../../aiContentProject.api';
import {
  RemoteAiContentBrief,
  RemoteAiContentProject,
} from '../../../aiContentProject.types';
import {setError, setProject} from '../aiContentProject.slice';

const updateAiContentProjectBrief = createAsyncThunk<
  RemoteAiContentProject,
  {projectId: number; brief: RemoteAiContentBrief},
  {state: RootState}
>(
  `${BreadcrumbName.AiContentProjectPage}/updateAiContentProjectBrief`,
  async ({projectId, brief}, {dispatch, getState, rejectWithValue}) => {
    const state = getState();
    const currentProject = state.aiContentProjectPage?.project;

    if (!currentProject || currentProject.id !== projectId) {
      return rejectWithValue('Project not loaded');
    }

    dispatch(setError(null));

    try {
      // Update with only brief, rest are null
      await aiContentProjectApi.updateAiContentProject({
        id: projectId,
        request: {
          name: null,
          brief,
          templateId: null,
          variationInputSchema: null,
        },
      });

      // Fetch the updated project
      const updatedProject = await aiContentProjectApi.getAiContentProjectById(
        projectId,
      );
      dispatch(setProject(updatedProject));

      return updatedProject;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to update brief';
      dispatch(setError(errorMessage));
      
      return rejectWithValue(errorMessage);
    }
  },
);

export default updateAiContentProjectBrief;

